import React, {Component} from 'react';
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import Alert from "react-s-alert";
import NavBarKS from "../../components/NavBarKS";
import UserServiceRightsTabView from "./component/UserServiceRightsTabView";
import StickButton from "../../components/StickButton";

class UserRights extends Component {
	constructor(props) {
		super(props);
		this.state = {
			alert: null,
			modules: [],
			userRights: [],
			fetchingRights: false,
			activeTab: null,
			mode: 'edit',
			isOpen: false,
			userName:"",

		};
		this.fetchData = this.fetchData.bind(this);
		this.handleSave = this.handleSave.bind(this);
		this.onChangeName = this.onChangeName.bind(this);
		this.onSelectRole = this.onSelectRole.bind(this);
		this.toggleTab = this.toggleTab.bind(this)
		this.setAuthModule = this.setAuthModule.bind(this)
	}

	componentDidMount() {
		if(this.props.match.params.userId)
			this.fetchData();
		else
			this.props.history.push("/");
	}

	toggleTab(tab) {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			});
		}
	}

	handleSave() {
		let self = this;
		let params = this.createRequestParams()

		this.setState({saving: true});

		request(params).then(function (response) {

			Alert.success("Kaydedildi", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000,
				html:false
			});

		}).catch(function (error) {
			showAxiosError(error);
		}).then(() => {
			self.setState({saving: false});
		});
	}

	onChangeName(e) {
		if (!e) return;
		e.preventDefault();

		let target = e.target;
		const value = target.value;

		this.setState({roleName: value, canSave: true})
	}

	onSelectRole(e) {
		if (!e) return;

		let value = e.value;
		let label = e.label;

		let currentRole = this.state.selectedRole
		if (currentRole === value) {
			return;
		}

		this.setState({
			selectedRole: value,
			roleName: label
		})
	}

	setAuthModule(value, i, j) {
		let {modules} = this.state;
		if (i === undefined && j === undefined) {
			//this.setState({roleName: value, canSave: true})
		} else {
			modules[i]["privileges"][j].selected = value;
			this.setState({modules, canSave: true}, () => console.log("modules", modules));
		}

	}

	fetchData() {
		let self = this;
		let userId = this.props.match.params.userId;
		if (!userId)
			return;
		let  userNameUrl = `/user/fetchUserName/${userId}`;
		let userNameParams = {
			url: userNameUrl,
			method: "post"
		}
		let params = {
			url: `/user/fetchUserRights/${userId}`,
			method: "get",
		};

		self.setState({fetchingRights: true});
		request(userNameParams).then((response) => {

			self.setState({userName: response.data});
			request(params)
				.then(function (response) {
					let modules = response.data && Array.isArray(response.data) ? response.data : [];
					self.setState({
						modules: modules,
						activeTab: modules ? modules[0].id : null,
						fetchingRights: false,
					});
				}).catch(function (error) {
				self.setState({fetchingRights: false});
				showAxiosError(error);
			});
		}).catch((error) => {
			showAxiosError(error);
		});
	}

	createRequestParams() {

		let userId=this.props.match.params.userId;
		let data = this.state.modules

		let params = {
			url: `/user/updateUserRights/${userId}`,
			method: 'post',
			data: data
		};

		return params;
	}


	onGoBack = (e) => {
		let self = this;
		self.props.history.push("/userList");
	}

	render() {
		let {modules, activeTab, canSave, saving} = this.state;
		return <div className="row baseBackground">
			<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth}>
				<StickButton position="leftSide" title="Kullanıcı Listesine Dön" label="Kullanıcı Listesine Dön"
							 className="zocial GeriDon" onClick={(e) => this.onGoBack(e)}/>
			</NavBarKS>
			{this.state.alert}
			<div className="col-md-12 satirBasi">
				<div className="">
					<div className="row card-header">
						<h4 className="baslik card-title">Kullanıcı Yetkilerini Düzenle
							<span className="float-right " style={ this.state.fetchingRights ? {} : {color:"#4f7f9f",paddingRight: "11px"}}>{this.state.fetchingRights  ? "Yükleniyor.." : this.state.userName}</span>
						</h4>
					</div>
					<div className="card-body">
						<br/>
						{ (this.state.fetchingRights)
							?
							<div className="col-sm-12 row">
								<i className="fas fa-spinner fa-spin"/>
							</div>
							:
							    this.state.modules.length !== 0 &&
								<UserServiceRightsTabView modules={modules}
													activeTab={activeTab}
													roleName={"roleName"}
													canSave={canSave}
													tabListener={this.toggleTab}
													saveListener={this.handleSave}
													showSaveButton={true}
													saving={saving}
													listener={this.setAuthModule}
								/>
							}
					</div>
				</div>
			</div>

		</div>;
	}
}

export default UserRights;